$(document).ready(function(){
  // 1. Initialize Slick
  // $('.js-slick-reviews').slick({
  //   dots: false,
  //   arrows: true,
  //   infinite: true,
  //   speed: 300,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   responsive: [
  //     { breakpoint: 1024, settings: { slidesToShow: 2 } },
  //     { breakpoint: 600, settings: { slidesToShow: 1 } }
  //   ]
  // });

  $('.js-slick-reviews').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        arrows: false,          
       
      }
    }
  ]
});

  // 2. Read More Functionality
  $('.review-text-content').each(function() {
    var $this = $(this);
    // Check if the actual height is greater than the visible height (7.5em = ~120px)
    if ($this.prop('scrollHeight') > 125) { 
      $this.after('<a class="read-more-btn">leggi di più...</a>');
    }
  });

  // 3. Click Event
  $(document).on('click', '.read-more-btn', function() {
    var $content = $(this).prev('.review-text-content');
    
    if ($content.hasClass('is-expanded')) {
      $content.removeClass('is-expanded');
      $(this).text('leggi di più...');
    } else {
      $content.addClass('is-expanded');
      $(this).text('meno');
    }
    
    // Optional: Re-calculate Slick height if using adaptiveHeight
    // $('.js-slick-reviews').slick('setPosition');
  });
});







function initSlickMarquee() {
  // 1. Check if jQuery and Slick exist
  if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {
    
    // 2. Target the static class instead of the Liquid ID
    var $sliders = jQuery('.js-marquee');
    
    $sliders.each(function() {
      var $this = jQuery(this);
      
      if (!$this.hasClass('slick-initialized')) {
        $this.slick({
          speed: 5000, // Speed of the transition
          autoplay: true,
          autoplaySpeed: 0,
          cssEase: 'linear',
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          swipeToSlide: true,
          arrows: false,
          dots: false,
          pauseOnHover: false,
          responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 4 } },
            { breakpoint: 768, settings: { slidesToShow: 3 } },
            { breakpoint: 480, settings: { slidesToShow: 2 } }
          ]
        });
      }
    });
  } else {
    // Retry if scripts aren't ready
    setTimeout(initSlickMarquee, 100);
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', initSlickMarquee);

// Initialize when a section is customized in the Theme Editor
document.addEventListener('shopify:section:load', function(event) {
  initSlickMarquee();
});


$(document).ready(function(){
  function mobileFooterAccordion() {
    if ($(window).width() < 567) {
      $('.footer-block--menu .footer-block__heading').off('click.footer');
      $('.footer-block--menu .footer-block__heading').on('click.footer', function(e) {
        e.preventDefault();
        let parent = $(this).closest('.footer-block--menu');

        // if already open → close it
        if (parent.hasClass('active')) {
          parent.removeClass('active');
          parent.find('.footer-block__details-content').stop(true, true).slideUp();
        } 
        else {
          // close others
          $('.footer-block--menu').removeClass('active')
            .find('.footer-block__details-content').stop(true, true).slideUp();

          // open current
          parent.addClass('active');
          parent.find('.footer-block__details-content').stop(true, true).slideDown();
        }
      });

    } else {
      // desktop reset
      $('.footer-block--menu .footer-block__details-content').show();
      $('.footer-block--menu').removeClass('active');
    }
  }

  mobileFooterAccordion();
  let resizeTimer;
  $(window).on('resize', function(){
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(mobileFooterAccordion, 200);
  });

});


function initGallerySlider() {
  var $slider = $('.gallery-slider');

  if ($slider.length && !$slider.hasClass('slick-initialized')) {
    $slider.slick({
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
             arrows: true
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.2,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
}

function initVideoLoaders() {
  var videos = document.querySelectorAll('.gallery-slider video');
  
  videos.forEach(function(video) {
    var loader = video.closest('.gallery-item-link').querySelector('.video-loader');
    if (!loader) return;

    // If the video is already buffered enough to play before the script runs
    if (video.readyState >= 3) {
      loader.style.display = 'none';
    }

    video.addEventListener('waiting', function() {
      loader.style.display = 'block';
    });

    video.addEventListener('playing', function() {
      loader.style.display = 'none';
    });

    video.addEventListener('canplay', function() {
      loader.style.display = 'none';
    });
  });
}

// Initialize on standard page load
$(document).ready(function () {
  initGallerySlider();
  initVideoLoaders();
});

// Initialize when working inside the Shopify Theme Editor
document.addEventListener('shopify:section:load', function() {
  initGallerySlider();
  initVideoLoaders();
});

jQuery(function ($) {
    if (!$('body').is('.gradient.cus_Pro_Class.anelloreale')) return;
    $('body.gradient.cus_Pro_Class.anelloreale').on('click', '#benefit-button', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $('#add-to-cart').offset().top - 300
        }, 600);
    });
});
document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector('.multicolumn.color-background-2.gradient.background-none');
  if (section) {
    section.classList.add('mobile-multicolumn-section');
  }
});
